import type { FC } from "react";
import { DashboardPptExportModal } from "pro-features/components/Dashboard/DashboardPptExportModal/DashboardPptExportModal";
import type { IDashboardExportListItem } from "pro-features/components/Dashboard/DashboardPptExportModal/DashboardPptExportModalTypes";

interface IDashboardPptExportModalContainerProps {
    isOpen: boolean;
    widgets: IDashboardExportListItem[];
    onClose: () => void;
    onExport: (widgetsToExport: IDashboardExportListItem[]) => Promise<void>;
}

export const DashboardPptExportModalContainer: FC<IDashboardPptExportModalContainerProps> = (props) => {
    const { widgets = [], isOpen, onClose, onExport } = props;
    return (
        <DashboardPptExportModal
            widgets={widgets}
            isOpen={isOpen}
            onClose={onClose}
            onExport={onExport}
        />
    );
};
